import React, { useEffect, useState } from "react";
import useApi from "../../hooks/useApi";

import ContentBox from "../../components/UI/ContentBox";
import Footer from "../../components/UI/Footer";
import Menu from "../../components/UI/Menu";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

import encarteavcontexto from "../../assets/docs/avcontexto.pdf";

import { useNavigate } from "react-router-dom";

import {
  Container,
  ContentText,
  Text,
  ViewImages,
  Images,
  Title,
  DivButtons,
  DivImages,
} from "./styles";
import Banner from "../../components/UI/Banner";
import { images } from "../../constants";
import ConfirmButton from "../../components/UI/ConfirmButton";

const openEncarte = () => {
  window.open(encarteavcontexto, "_blank");
};

const AvaliacaoContexto = () => {

  const [visibility,setVisibility] = useState(false);

  const [listContext, listContextInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/contextEvaluation",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        if(response.data.length>0){
          setVisibility(true);
        }
      }
    },
  });
  
  useEffect(() => {
    listContext({
      params: {
        idContent: "a825ead6-c54d-4956-a82a-3a0301dca109",
      },
    });
    // eslint-disable-next-line
  }, []);

  const navigate = useNavigate();

  const imagesGalery = [
    {
      original: images.edespecial1,
      thumbnail: images.edespecial1,
    },
    {
      original: images.edespecial2,
      thumbnail: images.edespecial2,
    },
    {
      original: images.edespecial3,
      thumbnail: images.edespecial3,
    },
    {
      original: images.edespecial4,
      thumbnail: images.edespecial4,
    },
    {
      original: images.edespecial5,
      thumbnail: images.edespecial5,
    }, 

  ];

  return (
    <Container>
      <Menu />
      <Banner icon={images.iconAvaliacao}>Avaliação de Contexto</Banner>
      <ContentBox>
{/*         
          <ViewImages>
            <Images>
              <ImageGallery 
              items={imagesGalery} 
              showBullets={true} 
              autoPlay={true} 
              showNav={false} 
              thumbnailPosition={"right"} 
              />
            </Images>
          </ViewImages> */}

        <DivButtons>

          <ConfirmButton onClick={openEncarte} text={"📘 Encarte Orientador"}></ConfirmButton>
          {visibility && <ConfirmButton text={"📝 Formulários de Coleta de Dados"} onClick={()=>{navigate(`/formularios/listar/a825ead6-c54d-4956-a82a-3a0301dca109`)}}></ConfirmButton>}
          {visibility && <ConfirmButton text={"📊 Dados por Unidade Escolar"} onClick={()=>{navigate(`/formularios/listarresultados/a825ead6-c54d-4956-a82a-3a0301dca109`)}}></ConfirmButton>}

        </DivButtons>

          <ContentText>
            <Title>1. APRESENTAÇÃO</Title>
            <Text> O Departamento Pedagógico disponibiliza este espaço como parte do compromisso com a qualidade, 
              a equidade e a transparência na Educação Infantil. Aqui estão reunidos o Encarte Orientador, os formulários 
              de coleta de dados, os resultados por eixo de análise e por unidade escolar, compondo um sistema integrado de 
              avaliação de contexto. </Text>
            <Text>A Avaliação de Contexto desloca o foco da análise do desempenho individual das crianças
               para as condições educativas oferecidas no cotidiano, considerando tempos, espaços, interações, práticas e materialidades.
            </Text>

            <Title>2. O que é a Avaliação de Contexto</Title>
            <Text> A avaliação em contexto se configura como:
              <li>um instrumento técnico-científico, com critérios claros de observação;</li>
              <li>uma prática político-pedagógica, comprometida com os direitos das crianças;</li>
              <li>um dispositivo formativo, que mobiliza reflexão, diálogo e transformação.</li>
              Ela permite compreender como as experiências das crianças acontecem no cotidiano, produzindo evidências que orientam decisões pedagógicas e de gestão.
            </Text>

            <Title>3. O cotidiano como eixo da avaliação</Title>
            <Text>A análise se organiza a partir dos oito momentos estruturantes do cotidiano, entendidos como dimensões pedagógicas:</Text>
            
            <DivImages>
              <Images src={images.chegada}></Images>
              <Images src={images.brincinternas}></Images>
              <Images src={images.brincexternas}></Images>
              <Images src={images.ativdirigidas}></Images>
            </DivImages>
            <DivImages>
              <Images src={images.higiene}></Images>
              <Images src={images.refeicoes}></Images>
              <Images src={images.descanso}></Images>
              <Images src={images.leitura}></Images>
            </DivImages>
            
            <Text> Esses momentos não são etapas isoladas, mas expressam o projeto pedagógico em ação, revelando concepções de infância, 
              intencionalidade docente e qualidade das interações. 
            </Text>

            <Title>4. Para que serve este conjunto de materiais</Title>
            <Text> Este ambiente foi estruturado para apoiar as unidades educacionais em três dimensões integradas:
            </Text>

            <Title>COMPREENDER</Title>
            <Text>O Encarte Orientador apresenta:</Text>
            <Text>
              <li>fundamentos da avaliação de contexto;</li>
              <li>articulação com currículo e diretrizes nacionais;</li>
              <li>leitura dos resultados da rede.</li>
            </Text>

            <Title>OBSERVAR E REGISTRAR</Title>
            <Text>Os Formulários de Coleta permitem:</Text>
            <Text>
              <li>observar o cotidiano com critérios comuns;</li>
              <li>registrar evidências concretas das práticas;</li>
              <li>tornar visíveis aspectos muitas vezes naturalizados.</li>
            </Text>

            <Title>ANALISAR E TRANSFORMAR</Title>
            <Text>Os Dados por Escola possibilitam:</Text>
            <Text>
              <li>leitura situada da própria realidade;</li>
              <li>identificação de potências e desafios;</li>
              <li>planejamento de ações formativas e pedagógicas.</li>
            </Text>

            <Title>5. Como os dados devem ser compreendidos</Title>
            <Text>Os dados produzidos:</Text>
            <Text>
              <li>não têm caráter classificatório ou fiscalizador;</li>
              <li>não se referem a indivíduos, mas a contextos;</li>
              <li>não indicam falhas, mas tendências e possibilidades de avanço.</li>
            </Text>
            <Text>Seu sentido está na capacidade de:</Text>
            <Text>→ transformar dados em reflexão</Text>
            <Text>→ transformar reflexão em planejamento</Text>
            <Text>→ transformar planejamento em práticas qualificadas</Text>

            <Title>6. O papel das unidades educacionais</Title>
            <Text>  Cada unidade é convidada a: </Text>


            <Text>
              <li>realizar sua própria avaliação de contexto;</li>
              <li>analisar seus dados de forma coletiva;</li>
              <li>articular os resultados ao:</li>
            </Text>
              <Text>° Projeto Político-Pedagógico;</Text>
              <Text>° Plano de Gestão;</Text>
              <Text>° Processos formativos.</Text>
            
            <Text>A avaliação se efetiva quando se transforma em ação institucional consciente e compartilhada.</Text>

            <Title>7. Compromisso com a equidade</Title>

            <Text>Os dados também evidenciam a necessidade de atenção a:</Text>
            <Text>
              <li>relações étnico-raciais;</li>
              <li>questões de gênero;</li>
              <li>práticas não discriminatórias;</li>
              <li>reconhecimento das crianças em sua diversidade.</li>
            </Text>

            <Text>A avaliação de contexto reafirma a Educação Infantil como espaço de justiça, pertencimento e dignidade.</Text>

        </ContentText>
      </ContentBox>
      <Footer />
    </Container>
  );
};

export default AvaliacaoContexto;